<template>
  <div class="detail-box position-header" v-loading="loading">
    <navHeader :titleList="['产品管理', '工厂产品', title + '工厂产品']" />
    <div class="detail-content common-padding">
      <el-card class="box-card">
        <el-row type="flex" justify="center">
          <el-col :span="10">
            <el-form ref="form" class="add-form" :rules="rules" :model="form" label-width="140px">
              <el-form-item label="驳回原因：" v-if="form.status === '3'">
                <p class="reject-text">{{ form.reason + '，请确认修改完成后点击提交审核' }}</p>
              </el-form-item>
              <el-form-item label="名称：" prop="name">
                <el-input v-model="form.name" :disabled="title === '编辑'"></el-input>
              </el-form-item>
              <el-form-item label="图片：" prop="pic">
                <uploadImage @success="getPicture" :img="pictureList" :limit="20" />
              </el-form-item>
              <el-form-item label="视频：" prop="videoUrl">
                <videoUpload @success="getVideo" :list="videoList" />
              </el-form-item>
              <el-form-item label="产品详情：" prop="detail">
                <editor ref="editor" @setHtml="setHtml" />
              </el-form-item>
              <el-form-item label="一级品类：" prop="oneList">
                <el-checkbox-group v-model="form.oneList" @change="oneChange" :max="3">
                  <template v-for="(item, index) in selectCategoryList">
                    <el-checkbox disabled :label="item.id" :key="index">{{
                        item.name
                    }}</el-checkbox>
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="二级品类：" prop="two">
                <span style="margin-right: 30px" v-for="(item, index) in twoList" :key="index"><el-radio
                    v-model="form.two" :key="inx" :label="i.id"
                    v-for="(i, inx) in item.data">{{ i.name }}</el-radio></span>
              </el-form-item>
              <!-- <el-form-item label="生产地：" prop="production">
                <el-select v-model="form.production" placeholder="请选择" style="width: 100%">
                  <el-option
                      v-for="item in areaCodeList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item label="寄样功能：" prop="sendSample">
                <el-radio-group v-model="form.sendSample">
                  <el-radio :label="item.id" v-for="item in sendSamples" :key="item.id">{{ item.name }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="今年新品：" prop="newProducts">
                <el-radio-group v-model="form.newProducts">
                  <el-radio label="0">否</el-radio>
                  <el-radio label="1">是</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="生产地：" prop="production">
                <el-select filterable v-model="form.production" placeholder="请选择" style="width: 100%">
                  <el-option v-for="(item, index) in addressList" :key="index" :label="item.address"
                    :value="item.address">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div class="info-footer">
              <el-button type="primary" @click="save">提交审核</el-button>
              <el-button @click="back">取消</el-button>
            </div>
          </el-col>
        </el-row>
      </el-card>
    </div>
  </div>
</template>
<script>
import navHeader from '../../components/navHeader.vue'
import uploadImage from '../../components/xcUpload.vue'
import editor from '../../components/editor.vue'
import videoUpload from '../../components/videoUpload'

export default {
  data () {
    return {
      loading: true,
      id: '',
      title: '添加',
      form: {
        detail: '',
        newProducts: '0',
        oneList: [],
        two: '',
        videoUrl: '',
        pic: '',
        sendSample: ''
      },
      providerRules: {
        firstCategory: {
          required: true,
          message: '请选择一级品类',
          trigger: 'change'
        }
      },
      pictureList: [],
      videoList: [],
      rules: {
        name: {
          required: true,
          message: '请输入中文名',
          trigger: 'blur'
        },
        pic: {
          required: true,
          message: '请上传图片',
          trigger: 'blur'
        },
        // sendSample: {
        //   required: true,
        //   message: '请选择寄样功能',
        //   trigger: 'blur'
        // },
        oneList: {
          required: true,
          message: '请选择一级品类',
          trigger: 'blur'
        },
        two: {
          required: true,
          message: '请选择二级品类',
          trigger: 'blur'
        },
        production: {
          required: true,
          message: '请选择生产地',
          trigger: 'blur'
        }
      },
      sendSamples: [
        {
          name: '可以寄样',
          id: '1'
        },
        {
          name: '可以参观/看样',
          id: '2'
        },
        {
          name: '可供产品资料',
          id: '3'
        },
        {
          name: '以上都不支持',
          id: '4'
        }
      ],
      selectCategoryList: [],
      brandCategoryList: [],
      areaCodeList: [],
      twoList: [],
      twoData: [],
      addressList: []
    }
  },
  components: {
    navHeader,
    uploadImage,
    editor,
    videoUpload
  },
  created () {
    if (this.$route.params.id) {
      this.id = this.$route.params.id
    } else {
      this.id = ''
    }
    if (this.$route.params.type) {
      this.type = this.$route.params.type
      this.title = '编辑'
    } else {
      this.type = 'add'
      this.loading = false
      this.title = '添加'
    }
    this.getBrandCategoryList()
    this.areaCode()
    this.getAddress()
  },
  mounted () {
    if (this.title === '添加') {
      this.$refs.editor.initEditor()
    }
  },

  methods: {
    getDetail (id) {
      this.$http.post('/factoryProduct/getById', { id }).then(res => {
        if (res.data.code === '200') {
          this.form = res.data.data
          this.$refs.editor.initEditor(this.form.detail)
          this.form.newProducts = res.data.data.newProducts ? res.data.data.newProducts : '0'
          this.pictureList = this.form.pic ? this.form.pic.split(',') : []
          this.videoList = []
          let list = this.form.videoUrl ? this.form.videoUrl.split(',') : []
          list.forEach(item => {
            this.videoList.push({ name: item, url: item })
          })
          console.log(this.videoList)
          this.getService()
        }
        this.loading = false
      }).catch(e => {
        console.log(e)
        this.loading = false
      })
    },
    getService () {
      this.$http.get('/company/getByFactoryCompany').then(res => {
        if (res.data.code === '200') {
          this.form.oneList = res.data.data.one ? res.data.data.one.split(',') : []
          this.twoList = []
          this.brandCategoryList.forEach((item) => {
            this.form.oneList.forEach((i) => {
              if (i === item.id) {
                this.selectCategoryList.push({
                  name: item.name,
                  id: item.id
                })
                this.twoList.push({
                  name: item.name,
                  id: item.id,
                  data: item.childList
                })
                let two = item.childList.map((n) => n.id)
                this.twoData.push(two.join(','))
              }
            })
          })
        }
      })
    },
    getBrandCategoryList () {
      this.$http.post('/brandCategory/getCategoryByType', { type: 3 }).then(res => {
        if (res.data.code === '200') {
          this.brandCategoryList = res.data.data
          if (this.id) {
            this.getDetail(this.id)
          } else {
            this.getService()
          }
        }
      })
    },
    getAddress () {
      this.$http.get('/factoryAddress/getFactoryAddressList').then(res => {
        console.log(res)
        if (res.data.code === '200') {
          res.data.data.forEach(item => {
            this.addressList.push({
              address: item.province + item.address
            })
          })
        }
      })
    },
    oneChange () {
      this.twoList = []
      this.twoData = []
      this.brandCategoryList.forEach((item) => {
        this.form.oneList.forEach((i) => {
          if (i === item.id) {
            this.twoList.push({
              name: item.name,
              id: item.id,
              data: item.childList.map((n) => n.name)
            })
            let two = item.childList.map((n) => n.id)
            this.twoData.push(two.join(','))
          }
        })
      })
    },
    getPicture (list) {
      this.form.pic = list.join(',')
    },
    getVideo (list) {
      this.form.videoUrl = list.map(item => item.url).join(',')
    },
    setHtml (html) {
      this.form.detail = html
    },
    areaCode () {
      this.$http
        .get('/areaCode/getList')
        .then((res) => {
          if (res.data.code === '200') {
            this.areaCodeList = res.data.data
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    back () {
      this.$router.push('/factoryProduct')
    },
    save () {
      this.$refs.form.validate(val => {
        if (val) {
          let params = JSON.parse(JSON.stringify(this.form))
          params.one = this.form.oneList.join(',')
          delete params.oneList
          let url = ''
          if (this.type === 'add') {
            url = '/factoryProduct/add'
          } else {
            url = '/factoryProduct/update'
          }
          this.$http.post(url, params).then(res => {
            if (res.data.code === '200') {
              this.$alert(res.data.msg, '提示', {
                confirmButtonText: '确定',
                showClose: false
              }).then(() => { this.$router.back() })
            } else {
              this.$message.error(res.data.msg)
            }
          }).catch(e => {
            console.log(e)
          })
        } else {
          if (!this.form.name) return this.$message.error('请输入中文名')
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/productManagement/factoryDetail.vue